<template>
  <div class="mt-5 md:mt-8">
    <CommonSectionLabel
      class="no-print order-last lg:order-none"
      title="MinisterQA"
      add-header-tag
    />
    <div class="container no-print">
      <LayoutColumns>
        <template #left> </template>
        <template #main>
          <ListQA
            class="order-last lg:order-none"
            :count="20"
            :show-more="true"
            placement="main"
            label="MinisterQA"
            label-link="Routes.QA"
          />
        </template>
        <template #right>
          <ListJobs
            class="order-last lg:order-none"
            :count="5"
            :random="true"
          />
        </template>
      </LayoutColumns>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const indexStore = useIndexStore()

if (!indexStore.currentPaper) {
  throw createError({ statusCode: 404 })
}

useSeoMeta({
  title: indexStore.currentPaperSlug
    ? config.public.site.meta.title.postfix.short +
      indexStore.currentPaper?.Name
    : config.public.site.meta.title.postfix.long,
})
</script>
